/**
 * Capitalizes the first letter of a string and makes the rest lowercase
 * @param {string} str 
 * @returns {string}
 */
export const capitalizeFirst = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
